const slides = [
  {
    image: "/images/slide1.jpg",
    alt: "Slide 01",
    caption: "carousel.caption.slide01",
    subCaption: "carousel.subcaption.slide01",
    defaultCaption: "FEEL THE ENERGY",
    defaultSubCaption: "Thrilling performance"
  },
  {
    image: "/images/slide2.jpg",
    alt: "Slide 02",
    caption: "carousel.caption.slide02",
    subCaption: "carousel.subcaption.slide02",
    defaultCaption: "SHAKE IT OUT",
    defaultSubCaption: "Rock Solid Sounds"
  },
  {
    image: "/images/slide3.jpg",
    alt: "Slide 03",
    caption: "carousel.caption.slide03",
    subCaption: "carousel.subcaption.slide03",
    defaultCaption: "ELETRONIC MADNESS",
    defaultSubCaption: "Thrilling performance"
  },
  {
    image: "/images/slide4.jpg",
    alt: "Slide 04",
    caption: "carousel.caption.slide04",
    subCaption: "carousel.subcaption.slide04",
    defaultCaption: "FEEL THE ENERGY",
    defaultSubCaption: "Thrilling performance"
  }
];

export default slides;
